import Switch from 'antd/lib/switch'
require('antd/lib/switch/style')
import styled from 'styled-components'
import { Colors } from '../../Themes'

const StyledSwitch = styled(Switch)`
  &.ant-switch-checked {
    background: ${Colors.emerald};
  }
`

export default StyledSwitch
